import React from 'react';
import B from '@vfuk/core-button';
const Button = props => {
    return React.createElement(B, Object.assign({}, props));
};
export default Button;
